/*
 * File: constants.js
 * Project: our-wave-stories-app
 *
 * Created by Brendan Michaelsen on June 13, 2024 at 9:45 AM
 * Copyright © 2024 Our Wave, Inc. All rights reserved.
 *
 * Last Modified: May 30, 2025 at 2:04 PM
 * Modified By: Brendan Michaelsen
 */

/**
 * Breakpoints
 */

// Max Width
export const xSmallBreakpoint = 22; // 20em
export const smallBreakpoint = 25; // 25em
export const mediumBreakpoint = 45; // 45em
export const largeBreakpoint = 60; // 60em
export const xLargeBreakpoint = 75; // 75em
export const xxLargeBreakpoint = 85; // 90em

// Min Width
export const mobileBreakpoint = 62; // 62em

// Topbar
export const buttonCopyBreakpoint = 30; // 30em
export const tabBarBreakpoint = 68; // 68em

// Masonry
export const masonryThreeBreakpoints = { 0: 1, 720: 2, 1500: 3 };
export const masonryFourBreakpoints = {
	0: 1, 800: 2, 1000: 3, 1400: 4
};
export const panelMasonryBreakpoints = { 0: 1, 720: 2 };


/**
 * Dimensions
 */

export const AppNavSidebarWidth = 340; // 340px
export const AppNavTopbarHeight = 68; // 68px
export const AppNavTopbarMobileSegmentHeight = 50; // 40px
export const LegalNavSidebarWidth = 250; // 250px
export const AnimationPanelWidth = 600; // 600px
export const ShareTopbarHeight = 68; // 50px
export const ShareBottomPadding = 100; // 100px
export const DetailPanelWidth = 800; // 800px


/**
 * Delays
 */

export const navigationDropdownDelay = 600;
